export const formatLocal = (date) => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;  // yyyy-mm-dd
};


export const  convertToDatePickerFormat = (dateStr) => {
  if (!dateStr) return null;
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12"
  };

  const [day, mon, year] = dateStr.split("-");

  return `${year}-${months[mon] || mon}-${day}`;
}


export  const invalidIds = ["PARM-014", "PARM-079", "PARM-002", "PARM-939"];